<script>
    export let event;

    let name = '';
    if(event.location && event.location.name) {
      name = event.location.name;
    }
</script>

<div>
    {name}
</div>

<style>
</style>